import { Blockchain } from '@/constants/blockchain'
import { BACKEND_PRIVATE } from '../base'

export async function meTransactionCreate(payload: any) {
  return BACKEND_PRIVATE.post('/me/transactions/create', { payload })
}

export async function getTransaction({
  scId,
  txId,
  event,
  blockchain,
}: {
  scId: string
  txId: string
  event: string
  blockchain: Blockchain
}) {
  return BACKEND_PRIVATE.get('/me/transactions/get', { params: scId ? { scId, event, blockchain } : { txId, event, blockchain } })
}

export async function getList({ limit, offset, status, event }: { limit?: number; offset?: number; status?: number; event?: string }) {
  return BACKEND_PRIVATE.get('/me/transactions/list', { params: { limit, offset, status, event } })
}
